import { render, staticRenderFns } from "./generateword.vue?vue&type=template&id=06a6c18e&scoped=true"
import script from "./generateword.vue?vue&type=script&lang=js"
export * from "./generateword.vue?vue&type=script&lang=js"
import style0 from "./generateword.vue?vue&type=style&index=0&id=06a6c18e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a6c18e",
  null
  
)

export default component.exports